import { render, staticRenderFns } from "./ManageCorrespondence.vue?vue&type=template&id=462afdfe"
import script from "./ManageCorrespondence.vue?vue&type=script&lang=js"
export * from "./ManageCorrespondence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports